/* @flow */
import PropTypes from 'prop-types';

import React from 'react';
import classNames from 'classnames';
import { ModalDialog } from '../SystemShared/ModalDialog';

export class CheckboxInput extends React.Component {
  constructor() {
    super();
    this.state = {
      isModalVisible: false,
    };
  }

  submitModal = () => {
    this.props.field.input.onChange(true);
    this.hideModal();
  };

  cancelModal = () => {
    this.hideModal();
  };

  hideModal = () => {
    this.setState({
      isModalVisible: false,
    });
  };

  showModal = (e) => {
    if (!(this.props.field.input.checked) && this.props.modalConfig) {
      e.preventDefault();
      this.setState({
        isModalVisible: true,
      });
    }
  };

  modalOnChangeHandler = () => {
    if (this.props.field.input.value) {
      this.props.field.input.onChange(false);
    }
  }

  render() {
    const {
      field,
      children,
      ariaLabelledBy,
      ariaDescribedBy,
      onKeyPress,
      qaTag,
      modalConfig,
      small,
    } = this.props;

    const divClasses = classNames({
      'has-error': field.meta.invalid,
      type: 'checkbox',
      'form-check': true,
      'mb-2': true
    });

    const inputClasses = classNames({
      'form-check-input': true
    });

    const labelClasses = classNames({
      'form-check-label': true,
      'small': small
    });

    return (
      <div className={divClasses}>
        <label className={labelClasses}>
          <input
            type="checkbox"
            id={field.input.name}
            className={inputClasses}
            { ...(field.input.value ? { checked: 'checked' } : { checked: '' })}
            onChange={modalConfig ? this.modalOnChangeHandler : field.input.onChange}
            onKeyPress={onKeyPress}
            aria-labelledby={ariaLabelledBy}
            aria-describedby={ariaDescribedBy}
            data-qa-item={qaTag}
            aria-invalid={field.meta.invalid}
            onClick={modalConfig ? this.showModal : null}
            disabled={this.props.disabled}
          />
          { children }
        </label>
        {modalConfig ?
          <ModalDialog show={this.state.isModalVisible}
            title={modalConfig.title}
            message={modalConfig.message }
            submitBtnText={ modalConfig.submitBtnText}
            hideBtnText={modalConfig.hideBtnText}
            onSubmit={this.submitModal}
            onHide={this.cancelModal}
          /> :
          null
        }
      </div>
    );
  }
}

CheckboxInput.propTypes = {
  field: PropTypes.object.isRequired,
  children: PropTypes.object,
  isInlineElement: PropTypes.bool,
  onKeyPress: PropTypes.func,
  ariaLabelledBy: PropTypes.string,
  ariaDescribedBy: PropTypes.string,
  qaTag: PropTypes.string,
  modalConfig: PropTypes.object,
  disabled: PropTypes.bool,
  small: PropTypes.bool,
};
